import { Box, Tooltip, Typography, useMediaQuery } from "@mui/material"
import React, { useState } from "react"
import "../../styles/appBar.scss";
import { Link, useLocation } from "react-router-dom";
import ModalPoolRisco from "../../pages/home/components/poolRisco";
const AppBar = () => {

    const api_externa = process.env.REACT_APP_API_EXTERNA ?? "/beneficiario";

    const isMobile = useMediaQuery("(max-width:768px)");

    const styleLi: React.CSSProperties = {
        padding: "0.5em 1em",
        cursor: "pointer",
        fontSize: isMobile ? "0.6em" : "1em"
    }
    const styleLink: React.CSSProperties = {
        textDecoration: "none",
        //backgroundColor: "#f3f3f3"
    }

    const RenderButtonBar: React.FC<{
        prefix: string, 
        title: string, 
        id: string, 
        to: string,
        target?: string,
        classNameActived: string
    }> = ({prefix, title, target, id, to, classNameActived}) => {

        const location = useLocation();
        
        const isActived = location.pathname === to ? true : false;

        return <Box component={Link} to={to} target={target} style={styleLink}>
            <Box 
                component="li" 
                className={isActived ? classNameActived : ""}
                id={!isActived ? id : ""}  
                style={{...styleLi}}
            > {prefix}<b>{title}</b> </Box>
        </Box>
    }
    const styleUl: React.CSSProperties = {
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
        alignContent: "center",
        justifyContent: "center",
        backgroundColor: "#b9def830",
        

    }
    const [open, setOpen] = useState<boolean>(false);

    const handleOpen = () => setOpen(true);

    const renderModal = () => {
        return <ModalPoolRisco open={open} setOpen={setOpen}/>
    }

    const renderPoolRisco = () => {
        return <Tooltip title="Baixar PDF">
            <Box
                component="button"
                onClick={handleOpen}
                sx={{
                border: "none",
                cursor: "pointer",
                //backgroundColor: "#f3f3f3", // Remove o fundo do botão
                padding: "0 1em", // Remove o padding padrão
                "&:hover": {
                    "& b": {
                    color: "#0786d0", // Altera a cor do texto ao passar o mouse
                    },
                },
                }}>
       
                <Typography color="#004387" style={{ fontSize: isMobile ? "0.6em" : "1em" }}>
                <b>Pool de Risco</b>
                </Typography>
            </Box>
        </Tooltip>
    }
    return <Box component="nav">
        {renderModal()}
        <Box component="ul" style={styleUl}>
            
            {/* Botão ocutado a pedido do Rodrigo */}

            {/* <RenderButtonBar 
                prefix="Sou " 
                title="Beneficiário" 
                id="beneficiario"
                target="_blank"
                to={api_externa}
                classNameActived="beneficiario-actived"
            /> */}
            <RenderButtonBar 
                prefix="Seja um " 
                title="Credenciado" 
                id="credenciado"
                to="/credenciado"
                classNameActived="credenciado-actived"
            />
            <RenderButtonBar 
                prefix="" 
                title="Faça sua cotação" 
                id="cotacao"
                to="/proposta"
                classNameActived="cotacao-actived"
            />
            {renderPoolRisco()}
        </Box>
    </Box>
}
export default AppBar;